import reduceReducers from 'reduce-reducers';

//Siblings reducers
import manageBookingReducer from './manage-booking-reducer';
import newBookingReducer from './new-booking-reducer';

export default reduceReducers(manageBookingReducer, newBookingReducer);
